/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { string, number } from 'prop-types';

import Spinner from 'components/Spinner/Spinner';
import FileInput from '../FileInput/FileInput';

import AddIcon from 'gfx/vector/add-icon.svg';

import styles from './add-picture.scss';

/**
 * This is the AddPicture component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class AddPicture extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {Object}
   */
  static propTypes = {
    id: string.isRequired,
    index: number.isRequired,
    preview: string,
  };

  static defaultProps = {
    preview: null,
  };

  /**
   * Create AddPicture.
   */
  constructor(props) {
    super(props);

    this.wrapper = React.createRef();

    this.state = {
      sending: false,
      error: null,
    };
  }

  onChange = () => {
    this.setState({
      sending: true,
      error: null,
    });
  };

  onError = error => {
    this.setState({
      sending: false,
      error,
    });
  };

  onComplete = () => {
    if (this.wrapper.current) {
      this.setState({
        sending: false,
        error: null,
      });
    }
  };

  /**
   * Render Upload.
   *
   * @return {Object}
   */
  render() {
    const { id, preview, index } = this.props;
    const { sending } = this.state;

    return (
      <div
        ref={this.wrapper}
        className={styles.button}

      >
        {sending && <Spinner medium />}

        {!sending && (
          <FileInput
            id={id}
            index={index}
            sending={sending}
            onChange={this.onChange}
            onError={this.onError}
            onComplete={this.onComplete}
            multiple
          >
            <span>
              <AddIcon />
            </span>
          </FileInput>
        )}
      </div>
    );
  }
}
